// extracted by mini-css-extract-plugin
export default {"pdf":"DownloadButtonPdf_pdf__hfbnc"};